












































import { Component, Prop, Vue , Watch } from 'vue-property-decorator';
// 印刷設定を流用
import DesignPreview from '@/views/printSetting/pagePreview/designPreview/designPreview.vue';
import DesignBorder from '@/views/printSetting/pagePreview/designBorder/designBorder.vue';
import DesignController from './designController/designController.vue';


// TODO document2
import { Page } from '@/model/document2/page/page'

import * as def from '@/definitions'
import { UuidHelper } from '@/helper/uuidHelper';
import { UnitHelper } from '@/helper/unitHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { Design } from '@/model/document2/page/surface/design/design';
import { Rectangle } from '@/utilityModels/rectangle'
import { MapHelper } from '@/helper/mapHelper';
import { Vector2 } from '@/utilityModels/vector2'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Const } from "@/const"


@Component({
  components: {
    DesignPreview,
    DesignBorder,
    DesignController
  },
})
export default class PagePreview extends Vue
{
    @Prop() private maxPage! : number
    @Prop() private maxPageInsertion! : number

    // ドラッグ先のデザイン *プレビュー表示用
    private dragOverDesignPosition = -1;

    get flowMode(){
        return this.$store.getters.applicationState.flowMode;
    }

    get pageNumberAry(){

        this.pageFrameStyle["z-index"] = this.maxPage + 1

        if(this.maxPage > 5){
            return new Array(5)
        }else{
            return new Array(this.maxPage)
        }

    }

    get pageNumberAryInsertion(){

        this.pageFrameStyleInsertion["z-index"] = this.maxPageInsertion + 1

        if(this.maxPageInsertion > 5){
            return new Array(5)
        }else{
            return new Array(this.maxPageInsertion)
        }

    }

    // ページ表示領域の基準サイズ。このサイズに収まるサイズが100%
    static readonly PAGE_BASE_WIDTH = 500;
    static readonly PAGE_BASE_HEIGHT = 700;

    // 固定pxとなるウィンドウサイズ
    static readonly FIXED_PX_BASE_WIDTH = 900;
    static readonly FIXED_PX_BASE_HEIGHT = 640;

    // サブコントロール用定義(本来の値の2/7)
    static readonly PAGE_BASE_WIDTH_SUB = 143;
    static readonly PAGE_BASE_HEIGHT_SUB = 200;

    private get pageBaseWidth() { return this.subControl ? PagePreview.PAGE_BASE_WIDTH_SUB : this.getPagePreviewBaseWidth(); }
    private get pageBaseHeight() { return this.subControl ? PagePreview.PAGE_BASE_HEIGHT_SUB : this.getPagePreviewBaseHeight(); }

    private getPagePreviewBaseWidth()
    {
        // ページ幅
        var pageWidth = this.page.width;
        // mm -> pt
        var pageWidthPt = UnitHelper.convert(pageWidth, "mm", "pt");
        // この値がpxと一致するような幅
        return pageWidthPt;
    }

    private getPagePreviewBaseHeight()
    {
        // ページ幅
        var pageHeight = this.page.height;
        // mm -> pt
        var pageHeightPt = UnitHelper.convert(pageHeight, "mm", "pt");
        // この値がpxと一致するような幅
        return pageHeightPt;
    }

    @Prop() private documentRotate! : number;
    @Prop() private page! : Page;
    @Prop() private pageWidth! : number;
    @Watch('pageWidth')
    onPageWidthChanged(val: number, oldVal: number)
    {
        if(val != oldVal)
        {
            this.adjustFrameSize();
            this.$nextTick(() => this.adjustFramePosition());
        }
    }
    @Prop() private pageHeight! : number;
    @Watch('pageHeight')
    onPageHeightChanged(val: number, oldVal: number)
    {
        if(val != oldVal)
        {
            this.adjustFrameSize();
            this.$nextTick(() => this.adjustFramePosition());
        }
    }
    @Prop() private bleedSize! : number;
    @Prop() private isReverse! : boolean;
    @Prop({default: 100}) private zoomScale! : number;
    @Watch('zoomScale')
    onZoomScaleChanged(val: number, oldVal: number)
    {
        DebugHelper.trace(this.zoomScale);
        this.adjustFrameSize();
        this.$nextTick(() => this.adjustFramePosition());
    }
    @Prop({default: false}) private isAutoZoom! : boolean;
    @Watch('isAutoZoom')
    onIsAutoZoomChanged(val: boolean, oldVal: boolean)
    {
        if(val) { this.autoResize(); }
        this.adjustFrameSize();
    }

    // サブコントロールとして存在する
    @Prop({default: false}) private subControl! : boolean

    @Prop({default: true}) private isFontLoaded! : boolean;

    private get isBorderVisible() { return true; }
    private borderColorRgb = this.$store.getters.userConfigColors.buttonColorRgb;
    // 枠色ピッカー表示フラグ
    private getBorderColor(position)
    {
        return position == this.page.currentDesignPosition ?
                            new ColorConstruct( this.borderColorRgb.r, this.borderColorRgb.g, this.borderColorRgb.b ) :
                            new ColorConstruct(151, 151, 151);
    }

    private pageFrameStyle = {};
    pageFrameStyleUnder(index){
        let pageFrameStyle : any = JSON.parse(JSON.stringify(this.pageFrameStyle));
        pageFrameStyle.top = "calc( " + pageFrameStyle.top + " + " + index * 5 + "px )" ;
        pageFrameStyle.left = "calc( " + pageFrameStyle.left + " + " + index * 5 + "px )" ;
        pageFrameStyle["z-index"] = this.maxPage - index;

        return pageFrameStyle;
    }

    private pageFrameStyleInsertion = {};
    pageFrameStyleUnderInsertion(index){
        let pageFrameStyle : any = JSON.parse(JSON.stringify(this.pageFrameStyleInsertion));
        pageFrameStyle.top = "calc( " + pageFrameStyle.top + " + " + index * 5 + "px )" ;
        pageFrameStyle.left = "calc( " + pageFrameStyle.left + " + " + index * 5 + "px )" ;
        pageFrameStyle["z-index"] = this.maxPageInsertion - index;

        return pageFrameStyle;
    }

    private get surface() { return this.page.getSurface(this.isReverse); }

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private get className()
    {
        if(UserAgentHelper.isMobile()) { return "layout-editor-page-preview-mobile"; }
        return this.subControl ? "sub-control-page-preview" : "layout-editor-page-preview";
    }

    // viewBox幅
    private get viewWidth() : number
    {
        return UnitHelper.convert(this.page.width, "mm", "px");
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return UnitHelper.convert(this.page.height, "mm", "px");
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get designs()
    {
        var array = new Array();
        var surface = this.page.getSurface(this.isReverse);
        for(var i = 0; i < this.page.designMaxNumber; ++i)
        {
            var design = surface.getDesign(i);
            array.push({
                design : design,
                position : i,
                key : UuidHelper.getUuid()
            });
        }
        return array;
    }

    // frameImage
    private get frameImageSource()
    {
        return this.page.getSurface(this.isReverse).getFrameImage(0);
    }

    private get frameImageWidth()
    {
        var baseWidth = this.documentRotate == 90 || this.documentRotate == 270 ? this.page.height : this.page.width;
        return UnitHelper.convert(baseWidth, "mm", "px");
    }

    private get frameImageHeight()
    {
        var baseHeight = this.documentRotate == 90 || this.documentRotate == 270 ? this.page.width : this.page.height;
        return UnitHelper.convert(baseHeight, "mm", "px");
    }

    private get frameImageTransform()
    {
        var transform = "";

        // オフセット
        // 回転角ごと適切な位置補正を加える
        var dx = 0;
        var dy = 0;
        let pageRotate = this.isReverse ? 
            (-this.documentRotate + 360) % 360 : this.documentRotate;
        if(pageRotate == 90)
        {
            dx = UnitHelper.convert(this.page.width, "mm", "px");
        }
        else if(pageRotate == 180)
        {
            dx = UnitHelper.convert(this.page.width, "mm", "px");
            dy = UnitHelper.convert(this.page.height, "mm", "px");
        }
        else if(pageRotate == 270)
        {
            dy = UnitHelper.convert(this.page.height, "mm", "px");
        }
        transform += "translate(" + dx + " " + dy + "),";

        // 用紙回転角で回転
        transform += "rotate(" + pageRotate + ")";

        return transform;
    }

    // 自動リサイズする
    private autoResize()
    {
        // サブコントロールの場合無効
        if(this.subControl) { return; }

        if(UserAgentHelper.isMobile())
        {
            // モバイルのみ、用紙サイズをもとにしてフレキシブルに計算する
            var pageWidthPx = UnitHelper.convert(this.page.width, "mm", "pt");
            var pageHeightPx = UnitHelper.convert(this.page.width, "mm", "pt");
            var wScale = (window.innerWidth - 16 * 2) / pageWidthPx;
            var hScale = (window.innerHeight - 16 * 2) / pageHeightPx;
            zoomScale = Math.min(wScale, hScale) * 100;
        }
        else
        {
            // サイズの調整
            var wScale = (Math.max(window.innerWidth, PagePreview.FIXED_PX_BASE_WIDTH) - 280) / PagePreview.PAGE_BASE_WIDTH;
            var hScale = (Math.max(window.innerHeight, PagePreview.FIXED_PX_BASE_HEIGHT) * 0.85  - 216) / PagePreview.PAGE_BASE_HEIGHT;
            var zoomScale = Math.min(wScale, hScale) * 100;
        }

        // 整数化
        zoomScale = Math.floor(zoomScale);
        if(zoomScale < 25) { zoomScale = 25; }
        if(zoomScale > 1000) { zoomScale = 1000; }
        this.onDoCommand("changeZoomScale", { scale : zoomScale });
    }

    mounted()
    {
        window.addEventListener('resize', this.onResize);

        if(this.isAutoZoom)
        {
            this.autoResize();
        }
        this.adjustFrameSize();
        this.$nextTick(() => this.adjustFramePosition());
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize()
    {
        if(this.isAutoZoom)
        {
            this.autoResize();
        }
        this.adjustFrameSize();
        this.$nextTick(() => this.adjustFramePosition());
    }

    private getBaseFrameSize()
    {
        // 倍率100%のときの基準サイズを取得する

        // 幅と高さの取得
        var pageWidth = this.page.width;
        var pageHeight = this.page.height;

        // 幅基準
        var width = this.pageBaseWidth;
        var height = width * pageHeight / pageWidth;
        if(height > this.pageBaseHeight)
        {
            // 高さ基準で再設定
            height = this.pageBaseHeight;
            width = height * pageWidth / pageHeight;
        }

        return { width: width, height: height };
    }


    // ズームを元にしてフレームの大きさを調整
    private adjustFrameSize()
    {
        var width = this.getBaseFrameSize().width * this.zoomScale / 100;
        var height = this.getBaseFrameSize().height * this.zoomScale / 100;
        this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "width", width + "px");
        this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "height", height + "px");
        this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "width", width + "px");
        this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "height", height + "px");
    }


    // フレームの位置を調整
    private adjustFramePosition()
    {
        var preview = this.$refs["layout-editor-page-preview"] as Element;
        var pageFrame = this.$refs["page-frame"] as Element;
        if(preview != null && pageFrame != null)
        {
            if((preview.clientHeight >= pageFrame.scrollHeight && preview.clientWidth >= pageFrame.scrollWidth))
            {
                // 全体中央揃え
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(-50%, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(-50%, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(-50%, -50%)");

                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "left", "50%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "top", "50%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(-50%, -50%)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(-50%, -50%)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(-50%, -50%)");
            }
            else if(preview.clientWidth >= pageFrame.scrollWidth)
            {
                // 左右のみ中央揃え
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "0%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(-50%, 0%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(-50%, 0%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(-50%, 0%)");

                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "left", "50%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "top", "0%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(-50%, 0%)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(-50%, 0%)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(-50%, 0%)");
            }
            else if(preview.clientHeight >= pageFrame.scrollHeight)
            {
                // 上下のみ中央揃え
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "0%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(0, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(0, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(0, -50%)");

                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "left", "0%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "top", "50%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(0, -50%)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(0, -50%)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(0, -50%)");
            }
            else
            {
                // 揃えない
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "0%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "0%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(0, 0)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(0, 0)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(0, 0)");

                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "left", "0%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "top", "0%");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(0, 0)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(0, 0)");
                this.pageFrameStyleInsertion = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(0, 0)");
            }
            DebugHelper.trace(this.pageFrameStyle);
        }
    }

    // マウスイベント
    private onDragOver(e)
    {
        // サブコントロールの場合無効
        if(this.subControl) { return; }
        // デフォルト処理を禁止しないと、dropイベントが流れない
        e.preventDefault();

        var current = e.target;
        if(this.isDesignControllerClassName(current.className))
        {
            // デザインへのドラッグ
            var to = this.getDesignPositionFromClassName(current.className);
            this.dragOverDesignPosition = to;
        }
        else 
        {
            this.dragOverDesignPosition = -1;
        }
    }

    static readonly DESIGN_CONTROLLER_CLASS_NAME = "design-controller_";

    private getDesignControllerClassName(position : number)
    {
        return PagePreview.DESIGN_CONTROLLER_CLASS_NAME + position;
    }

    private isDesignControllerClassName(className : string)
    {
        return className.indexOf(PagePreview.DESIGN_CONTROLLER_CLASS_NAME) >= 0;
    }

    private getDesignPositionFromClassName(className : string)
    {
        var substr = className.substring(PagePreview.DESIGN_CONTROLLER_CLASS_NAME.length);
        return Number(substr);
    }

    private onDrop(e)
    {
        e.preventDefault();

        var isPageFrame = false;
        var current = e.target;

        if(this.isDesignControllerClassName(current.className))
        {
            // デザインへのドラッグ
            var to = this.getDesignPositionFromClassName(current.className);
            this.onDoCommand("dropToDesign", { position : to });
        }
        else
        {
            while(current != null)
            {
                if(current.className == "page-frame")
                {
                    isPageFrame = true;
                    break;
                }
                // 親のノードを取得
                current = current.parentNode;
            }

            if(!isPageFrame)
            {
                // ページ外へのドロップ
                this.onDoCommand("dropOutside", null);
            }
        }

        this.dragOverDesignPosition = -1;
    }

    private onSelect(index)
    {
        this.onDoCommand("selectDesign", { position : index });
    }

    private onEdit(index)
    {
        this.onDoCommand("createDesign", null);
    }

    private onShowContextMenu(event)
    {
        if(this.subControl) { return; }
        this.onDoCommand("showContextMenu", { event : event });
    }

    private onDragDesignStart(index)
    {
        if(this.subControl) { return; }
        this.onDoCommand("startDragDesign", { position : index });
    }

    private onDragDesignEnd(index)
    {
        if(this.subControl) { return; }
        this.onDoCommand("endDragDesign", { position : index });
    }
}
